import { ViewCustomers } from '@enmon/commons/lib/enmon';
import { useServices } from 'containers/services';
import type { GetCustomersArg, GetCustomersResponse } from 'lib/services';
import { type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import { useAppNotifications } from '../../../hooks';
import { getErrorMessage } from '../../../utils/getErrorMessage';

export const useCustomers = <TView extends ViewCustomers = ViewCustomers.Default>(
  { filter, view }: GetCustomersArg = { filter: {}, view: ViewCustomers.Default },
): UseQueryResult<GetCustomersResponse<TView>> => {
  const notify = useAppNotifications();
  const {
    backendGateway: { customersApiClient },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.customers.filter({ filter, view }),
    queryFn: async () => await customersApiClient.find<TView>({ filter, view }),
    onError: error =>
      notify.error({
        message: 'There was an error while fetching customers',
        description: error instanceof Error ? getErrorMessage(error) : undefined,
      }),
  });
};
